module.exports = __webpack_public_path__ + "static/img/case-dy-page-bg-02.72a9ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dy/case-dy-page-bg-02.jpg
// module id = +4Mq
// module chunks = 1